module.exports = __webpack_public_path__ + "static/media/loan11.bec91b8e.png";